// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore"; // <<< UNCOMMENT THIS
// import { getStorage } from "firebase/storage"; // Keep commented if not using Storage yet

// Your web app's Firebase configuration - REPLACE THIS WITH YOURS
const firebaseConfig = {
  apiKey: "AIzaSyAyVsq1cf5QnEsTtlFr_LYcKnAwHBnOdBU",
  authDomain: "freelancer-ideas-portal.firebaseapp.com",
  projectId: "freelancer-ideas-portal",
  storageBucket: "freelancer-ideas-portal.firebasestorage.app",
  messagingSenderId: "471922537650",
  appId: "1:471922537650:web:68fb4d133354681d29c5ab"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
const auth = getAuth(app);
const db = getFirestore(app); // <<< UNCOMMENT AND INITIALIZE db
// const storage = getStorage(app);

// Export the services you'll need
export { auth, db /*, storage */ }; // <<< EXPORT db
export default app;